import PricingHandler from "./contracts/PricingHandler";
import IResolvedPricing from "./contracts/IResolvedPricing";
import IPricingComposite from "./contracts/IPricingComposite";
import Config from "./contracts/Config";

/**
 * Processes input pricing data through a chain of responsibility to resolve the final display price.
 * @remarks
 *  Use presets for common scenarios, or individual handlers for specific pricing logic. If necessary,
 *  the responsibility chain can accept custom PricingHandler implementations.
 */
const evaluateDisplayPrice = (
  input: IPricingComposite,
  responsibilityChain: PricingHandler<IPricingComposite>[],
  config: Config = { log: false },
) => {
  const handlerIterator = getIterator(responsibilityChain);

  let resolvedPricing: IResolvedPricing = { price: 0 };

  do {
    const { done, value: handler } = handlerIterator.next(); // returns the next handler in the chain
    if (done) break;

    // value here is the handler function
    const newPricing = handler(input, resolvedPricing);

    if (config.log) console.log(handler.name, resolvedPricing, newPricing);

    resolvedPricing = newPricing;
    // eslint-disable-next-line no-constant-condition
  } while (true);

  return resolvedPricing;
};

/**
 * Creates an iterator for the responsibility chain of pricing handlers.
 * @param responsibilityChain
 */
export function* getIterator(
  responsibilityChain: PricingHandler<IPricingComposite>[],
) {
  for (const handler of responsibilityChain) yield handler;
}

export default evaluateDisplayPrice;
